"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Card = _interopRequireDefault(require("../../Card/Card"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var FlexBanner = function FlexBanner(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_Card["default"], {
    template: "ImageCard",
    icon: "",
    imageCardTemplate: "Banner",
    heading: data.title,
    subheading: data.subtitle,
    size: "xs",
    bgImage: data.image ? data.image : '',
    whiteFont: data.image,
    overlay: data.image
  }));
};
FlexBanner.propTypes = {
  data: _propTypes["default"].object
};
var _default = exports["default"] = FlexBanner;